import __find from 'lodash/find'

import { CompanyIntegrationProviders, INVOICE_SOURCE_VALUES } from '@constants'

//* COMPANY INTEGRATION HELPERS *//
function getCompanyIntegrations(state: Store) {
  return state.auth.company.data?.integrations || []
}

function findCompanyIntegration(state: Store, integration: CompanyIntegrationProviders) {
  const integrations = getCompanyIntegrations(state)

  return __find(integrations, obj => obj.integration === integration)
}

/**
 * Generic helper to check if company has the given integration type
 * @param state - redux store
 * @param integrationType - integration type
 * @returns - true if company has the given integration type
 */
export function companyHasIntegrationType(state: Store, integrationType: CompanyIntegrationProviders) {
  return Boolean(findCompanyIntegration(state, integrationType))
}

export function getSzamlazzHuBackUrl(state: Store) {
  const szamlazzHuIntegration = findCompanyIntegration(state, CompanyIntegrationProviders.szamlazz)
  return szamlazzHuIntegration?.back_url
}

export function companyHasIntegration(state: Store) {
  const integrations = getCompanyIntegrations(state)
  return integrations.length > 0
}

//* INVOICE INTEGRATION HELPERS *//
// Invoice
// income page uses this because no nav there
export function isIntegrationInvoice(data: ExpenseDetailsFrontendValues | IncomeDetailsFrontendValues) {
  return data.integration_type != null // not null or not undefined
}

// V1 helper
export function isNAVInvoice(data: ExpenseDetailsFrontendValues | IncomeDetailsFrontendValues) {
  return data.source === INVOICE_SOURCE_VALUES.SZAMLA_SOURCE_NAV // expense, quarantine, incomes list and details
}
// expense and quarantine pages use this because nav there
// only show integration when quarantine_status is null
export function isIntegrationInvoiceWithoutNav(data: ExpenseDetailsFrontendValues | IncomeDetailsFrontendValues) {
  return isIntegrationInvoice(data) && !isNAVInvoice(data)
}

//* PARTNER INTEGRATION HELPERS *//
// note: partners module is not typed yet
export const isBillingoPartner = (data: { integration_type: number[] }) =>
  (data?.integration_type || []).includes(CompanyIntegrationProviders.billingo)
export const isSzlahuPartner = (data: { integration_type: number[] }) =>
  (data?.integration_type || []).includes(CompanyIntegrationProviders.szamlazz)
export const hasIntegration = (data: { integration_type: number[] }) => (data?.integration_type || []).length > 0
